import React from 'react';
import { StyleSheetManager, withTheme, ThemeProvider } from 'styled-components';

import Frame from './styled-frame/Frame';
import { FrameContextConsumer } from './styled-frame/Context';

// Mostly taken from https://github.com/hydrateio/react-styled-frame
export default withTheme(({ children, style = {}, theme, ...rest }) => (
  <Frame
    style={{
      display: 'block',
      overflow: 'scroll',
      border: 0,
      ...style,
    }}
    {...rest}
  >
    <FrameContextConsumer>
      {(frameContext) => (
        <StyleSheetManager target={frameContext.document.head}>
          {theme ? (
            <ThemeProvider theme={theme}>{children}</ThemeProvider>
          ) : (
            children
          )}
        </StyleSheetManager>
      )}
    </FrameContextConsumer>
  </Frame>
));
